import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { Reveal, Overline } from "./Reveal";
import { track } from "@/lib/analytics";

export const FAQ_HOME = [
  { q: "Quais serviços a Melo Agro Engenharia oferece?", a: "Oito frentes: Projetos de Crédito Rural; Avaliações de imóveis rurais e urbanos e de máquinas agrícolas (ABNT NBR 14653); Laudos Técnicos Agronômicos; Perícias Agrícolas e Judiciais; Regularização Rural (CAR, CCIR e ITR); Assessoria Especializada bancária e jurídica; Reestruturação de Crédito Rural; e Seguros Agrícolas." },
  { q: "Em quais regiões vocês atendem?", a: "Somos sediados em Pelotas e atendemos toda a metade sul do Rio Grande do Sul — inclusive Canguçu, Piratini, São Lourenço do Sul, Capão do Leão, Jaguarão, Herval, Camaquã e Rio Grande, entre outros municípios da Metade Sul do RS." },
  { q: "Como funciona o primeiro contato?", a: "É simples: chame no WhatsApp ou mande a mensagem pelo formulário do site. Entendemos o seu caso, explicamos o que pode ser feito e só depois começamos o serviço — sem compromisso na primeira conversa." },
  { q: "Os laudos têm aceitação em bancos e cartórios?", a: "Os documentos saem com responsável técnico registrado no CREA-RS, com ART, e seguem as normas aplicáveis, como a ABNT NBR 14653 nas avaliações. A aceitação final é sempre decisão da instituição." },
  { q: "Vocês ajudam quem está com dívida rural?", a: "Sim. A frente de reestruturação de crédito rural faz o levantamento das dívidas, analisa a situação da produção e acompanha a renegociação junto ao agente financeiro." },
  { q: "Preciso estar com a documentação do imóvel em dia?", a: "Ajuda bastante — e, se houver pendências no CAR, CCIR ou ITR, cuidamos da regularização em conjunto com a sua demanda principal." },
  { q: "Quanto custa um laudo ou um projeto?", a: "O valor depende do serviço, do tamanho da área e da complexidade do caso. Após o diagnóstico inicial, enviamos um orçamento claro, sem compromisso." },
  { q: "Atendem pequenos produtores e agricultura familiar?", a: "Atendem. Trabalhamos desde a agricultura familiar — inclusive com o Pronaf — até grandes operações da Metade Sul do RS." },
];

export const FaqHome = () => {
  const [open, setOpen] = useState(-1);

  return (
    <section id="faq" data-testid="faq-home-section" className="mx-auto max-w-[900px] px-5 py-10 sm:px-8 sm:py-14 md:py-28">
      <Reveal><Overline>Perguntas frequentes</Overline></Reveal>
      <Reveal delay={0.1}>
        <h2 className="mt-6 font-serif text-4xl leading-[1.05] tracking-tight text-[#1A2218] sm:mt-8 sm:text-5xl">
          As dúvidas que mais chegam <em className="text-[#233D25]">até nós.</em>
        </h2>
      </Reveal>
      <div className="mt-8" data-testid="faq-home-list">
        {FAQ_HOME.map((f, i) => (
          <div key={f.q} className="border-b border-[#E5E0D5]">
            <button
              data-testid={`faq-home-q${i + 1}`}
              onClick={() => {
                setOpen(open === i ? -1 : i);
                if (open !== i) track("faq_aberta", { pergunta: f.q });
              }}
              className="flex w-full items-center justify-between gap-4 py-3 text-left sm:py-4"
              aria-expanded={open === i}
            >
              <span className="text-base font-medium text-[#1A2218] sm:text-lg">{f.q}</span>
              <ChevronDown className={`h-5 w-5 shrink-0 text-[#5D995E] transition-transform duration-300 ${open === i ? "rotate-180" : ""}`} />
            </button>
            <div className={`grid transition-[grid-template-rows] duration-300 ${open === i ? "grid-rows-[1fr]" : "grid-rows-[0fr]"}`}>
              <div className="overflow-hidden">
                <p className="pb-5 text-base leading-relaxed text-[#4A5549]">{f.a}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};
